import router from '@/router'
import { Toast, Dialog } from "vant";
import CryptoJS from 'crypto-js'

// import dic from '@/utils/dictionaryData'
// import { NumbertoMultiply, NumbertoSubtract } from '@/utils/accuracyCalculation'

import store from '@/store'
import { getJsApiSignApi } from '@/api/communal'
import { reqUploadSign, reqUploadRequest } from '@/api/communal'


/**
 * 获取url中参数值
 * @param {any} name:string
 * @returns {any}
 */
export const getQueryString = (name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 获取路由上query参数
export function getRouteQuery() {
  const { currentRoute } = router
  const { query } = currentRoute.value
  return JSON.parse(JSON.stringify(query))
}

/*
 * 删除对象空属性
 */
export const deleteObjUndefined = (myObj) => {
  Object.keys(myObj).forEach((key) => (myObj[key] == null || myObj[key] == undefined) && delete myObj[key]);
}
// 是否是微信环境
export function isWechat() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}
// 微信api授权
export const wxApiEmpower = () => {
  if (!isWechat()) return
  return new Promise((resolve, reject) => {
    getJsApiSignApi().then((result) => {
      // eslint-disable-next-line no-undef
      wx.config({
        beta: true,
        debug: false,
        appId: result.data.appid,
        timestamp: result.data.timestamp,
        nonceStr: result.data.noncestr,
        signature: result.data.signature,
        jsApiList: ['getLocation', 'hideMenuItems', 'hideAllNonBaseMenuItem', 'updateAppMessageShareData', 'updateTimelineShareData', 'closeWindow'],
        openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp']
      })
      // eslint-disable-next-line no-undef
      wx.ready((res) => {
        // console.log('消息通知config成功')
        resolve(res)
      })
      // eslint-disable-next-line no-undef
      wx.error((error) => {
        console.log('消息通知config失败')
        console.log(error)
        reject(error)
      })
    })
  })
}

// 设置title
export function setDocumentTitle(title) {
  document.title = title
}
// 手机号和用户信息授权
export function userAuthorization() {
  let { nickname, headImage, phone } = store.state.userInfo
  if (!(phone)) return navigateTo('/phoneLogin')
  if (!(nickname && headImage)) return navigateTo('/snsapiUserinfo')
  return 'pass'
}


// 跳转到应用内的某个页面。
export const navigateTo = (url) => {
  router.push(url)
}
// 关闭所有页面，打开到应用内的某个页面
export const reLaunch = (url) => {
  router.replace(url)
}
// 跳转到其他小程序
export const toMiniProgram = (item) => {
  store.commit('setYdJumpAppletPopItem', {
    ydJumpAppletPopItem: item
  })
  store.commit('setYdJumpAppletPopShow', {
    ydJumpAppletPopShow: true
  })
}
// 打开h5页面
export const toWebviewPage = (url) => {
  window.location.href = url
}
// 返回上一页
export const navigateBack = () => {
  router.go(-1)
}
// 关闭当前页面，跳转到应用内的某个页面
export const redirectTo = (url) => {
  router.replace(url)
}

// 多类型的跳转 skipType: 0： 无，1：h5, 2:小程序
export const multiTypeJumpDrump = (item) => {
  switch (item.jumpType) {
    case 1:
      toWebviewPage(item.h5Link)
      break;
    case 2:
      toMiniProgram({
        path: item.path,
        appId: item.appId
      })
      break;
  }
}

// 数据判空
export const dataIsEmpty = (value) => {
  if (Array.isArray(value) && value.length === 0) return true
  if (typeof value !== 'number') return !value
  return false
}

// 弹窗
export function showToast(val) {
  let type = typeof val
  let _length = 0
  let isCustomerService = false // 是否联系客服
  let maxLenght = 25
  switch (type) {
    case 'string':
      _length = val.length
      isCustomerService = val.includes('联系客服')
      if (_length > maxLenght || isCustomerService) {
        Dialog.alert({
          message: val,
        })
      } else {
        Toast({
          message: val,
        })
      }
      break;
    case 'object':
      _length = val.message.length
      isCustomerService = val.message.includes('联系客服')
      if (_length > maxLenght || isCustomerService) {
        Dialog.alert(val)
      } else {
        Toast(val)
      }
      break;
  }
}



// 图片上传 参数：(文件)
export function handleRequestExtract(file,) {
  return new Promise((resolve, reject) => {
    try {
      //上传oss
      const canvas = document.createElement('canvas') // 创建Canvas对象(画布)
      const context = canvas.getContext('2d')
      const img = new Image()
      img.src = file.content // 指定图片的DataURL(图片的base64编码数据)
      img.onload = function () {
        // 画布大小 这里的this指向img
        canvas.width = this.width
        canvas.height = this.height
        context.drawImage(img, 0, 0, this.width, this.height) // 图片大小
        file.content = canvas.toDataURL(file.file.type, 0.5) // 0.92为默认压缩质量
      }
      //先获取签名
      reqUploadSign().then((res) => {
        if (res && res.data) {
          // console.log(res);
          const data = res.data
          const ossData = new FormData()
          ossData.append('name', file.file.name)
          // key就代表文件层级和阿里云上的文件名
          const arr = file.file.name.split('.')
          const imgType = arr[arr.length - 1]
          let name = arr.slice(0, -1)
          name = name.join('.')
          const time = formatDate(new Date(), '{y}{m}{d}{h}{i}{s}')
          // 文件名，文件大小，时间戳（yyyyMMddHHmmss）文件类型
          const filename = `${name}&${file.file.size}&${time}.${imgType}`
          const keyValue = data.dir + filename
          ossData.append('key', keyValue)
          for (const i in data.callbackVar) {
            ossData.append(i, data.callbackVar[i])
          }
          ossData.append('policy', data.policy)
          ossData.append('callback', data.callback)
          ossData.append('OSSAccessKeyId', data.accessid)
          ossData.append('success_action_status', 201)
          ossData.append('signature', data.signature)
          ossData.append('file', file.file, file.file.name)
          const toast = Toast.loading({
            message: '上传中...',
            duration: 0, // 持续展示 toast
            forbidClick: true,
            loadingType: 'spinner'
          })
          reqUploadRequest(data.host, ossData)
            .then(res => {
              toast.clear()
              if (res.status === 200) {
                const response = res.data
                if (response.code === 0) {
                  resolve(response.data.host) // 图片返回
                }
              } else {
                Toast.fail('上传失败，请重试！')
                reject(res)
              }
            })
            .catch(() => {
              file.onError()
            })
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}

/**
 * 描述 时间处理
 * @date 2020-04-09
 * @param {any} date:any
 * @param {any} fmt:string
 * @returns {any}
 */
export const formatDate = (time, cFormat) => {
  if (!time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

const AESKey = CryptoJS.enc.Utf8.parse('385f33cb91484b04a177828825621ab7') // 接口数据传输加解密-密钥

// 接口数据传输的加密方法
export function encryption(jsonData) {
  if (!jsonData) return null
  let content = JSON.stringify(jsonData)
  const encryptedContent = CryptoJS.AES.encrypt(content, AESKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  const encStr = encryptedContent.ciphertext.toString()
  return encStr
}

// 判断是否支持WebP
export function isSupportWebP() {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.width > 0 && img.height > 0);
    img.onerror = () => resolve(false);
    img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
  });
}